import React, { useEffect, useRef, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import TopFilter from '../components/TopFilter';
import RightFilterToggle from '../components/RightFilterToggle';
import paginationFactory from 'react-bootstrap-table2-paginator';
import GridData from '../components/gridmodal/GridDataPackages';
// import { propTypes } from 'react-bootstrap/esm/Image';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.css';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
// import PriceFilter from '../components/CustomGridFilter';
import configData from '../configData.json';
import { format } from 'date-fns';
import Spinner from 'react-bootstrap/Spinner';
import ColumnFilter from '../components/ColumnFilter';
import { Link } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import LeftMenu from '../components/LeftMenu';
import ForecastRightFilterToggle from '../components/ForecastRightFilterToggle';
import MycustomDesignGrid from '../components/MycustomDesignGrid';
import SettingsRightFilterToggle from '../components/Settings/SettingsRightFilterToggle';
import SettingsTopFilter from '../components/Settings/SettingsTopFilter';
import { toLocalDate } from '../components/Utlities';

export default function BusinessReviewReport() {

    const [BusinessRevRpt, setBusinessRevRpt] = useState([]);
    const [DetailByCustCarr, setDetailData] = useState([]);
    const [selectedSummaryRow, setSelectedRow] = useState({});
    const [lastElement, setLastElement] = useState(null);
    const [hidden, setHidden] = useState(true);
    const [fbNum, setFbNum] = useState("");
    const [acctNo, setAcctNo] = useState("");

    const [ownKey, setOwnerKey] = useState(0);
    const [custKey, setCustomerKey] = useState(0);


    const [pstNumOfWk, setPstNumOfWk] = useState(0);
    const [imPstNumWk, setImPstNumWk] = useState(0);
    const [perDecrease, setPerDecrease] = useState(0);
    const [perIncrease, setPerIncrease] = useState(0);

    const { ExportCSVButton } = CSVExport;
    const { ExportCSVButtonDetail } = CSVExport;

    const [fromDate, setFromDate] = useState(undefined);
    const [toDate, setToDate] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [fbLoading, setFBLoading] = useState(false);
    const [prevY, setPrevY] = useState(0);
    const [dateDivVisible, setDateDivVisible] = useState(false); // State to control visibility


    let prevYRef = useRef({});
    let selectedRowRef = useRef({});
    let DetailByCustCarrRef = useRef({});
    let hiddenRef = useRef({});
    let pageRef = useRef({});

    prevYRef.current = prevY;
    selectedRowRef.current = selectedSummaryRow;
    DetailByCustCarrRef.current = DetailByCustCarr;
    hiddenRef.current = hidden;
    pageRef.current = page;

    const criData = [
        { criKey: 1, criValue: 'Owner' },
        { criKey: 2, criValue: 'Customer' },
        // { criKey: 2, criValue: 'Transportation Provider' },
        // { criKey: 3, criValue: 'Freight Bill Number' },
        // { criKey: 4, criValue: 'Transportation Provider Account Number' }
        // { criKey: 6, criValue: 'Division' },
    ];

    const searchOnClick = (ownerKey, customerKey) => {

        // debugger;
        setCustomerKey(customerKey);
        LoadSummaryData(ownerKey, customerKey);
    }

    const LoadSummaryData = async (ownerKey, customerKey) => {
        debugger;
        setLoading(true);
        setBusinessRevRpt([]);
        const URL = `${configData.BASE_APP_URL}CustomerSetup/GetCustomerSettings/${customerKey}/${ownerKey}`;
        console.log(URL);

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            const data = await response.json();

            // Filter the data to get objects where serviceType is "BR"
            const filteredData = data.filter(item => item.serviceType === "BR");

            setBusinessRevRpt(filteredData);
            setLoading(false);
        } catch (error) {
            // Handle any errors here
            console.error("Error loading summary data:", error);
            setLoading(false);
        }
    }


    const DownloadSummaryData = async () => {

        const URL = `${configData.BASE_APP_URL}VolumeByCustomer/GenerateExcelForBusiness`;
        console.log(URL);

        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: BusinessRevRpt }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `Business Review Report.xlsx`;
        link.click();

    };


    const NumberFormatter = (cell, row, rowIndex, formatExtraData) => {
        let isTotal = false;
        if (row.billType === 'TOTAL') {
            isTotal = true
        }

        return (
            isTotal == true
                ? <span><b>{cell}</b></span>
                : <span>{cell}</span>
        );
    }

    const AmountFormatter = (cell, row, rowIndex, formatExtraData) => {
        let isTotal = false;
        if (row.billType === 'TOTAL') {
            isTotal = true
        }
        return (
            isTotal == true
                ? <span><b><span>{parseFloat(cell).toFixed(2)}</span></b></span>
                : <span><span>{parseFloat(cell).toFixed(2)}</span></span>

        )
    }

    const AmountFormatterCsv = (cell) => {
        return `"${cell.toFixed(2)}"`;
    }

    const columnFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <div>
                <span><a href='#'><i className="fa fa-expand mr-1"></i></a>{row.customerName}</span>
            </div>
        )
    }


    const freightBillFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=" + '"' + cell + '"'
        )
    }

    const invoicenumberFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=" + '"' + cell + '"'
        )
    }
    const accountnumberFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=" + '"' + cell + '"'
        )
    }


    const invoiceDateFormatter = (cell, row, rowIndex, formatExtraData) => {
        if (cell === "" || cell === null) {
            return <span></span>; // Returning an empty span when serviceType is "CA"
        }
        else {
            return (
                <span>{format(toLocalDate(cell), "MM/dd/yyyy")}</span>
            );
        }
    }

    const invoiceDateFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        if (cell === "" || cell === null) {
            return ""; // Returning an empty span when serviceType is "CA"
        }
        else {
            let newDate = format(new Date(cell), "MM/dd/yyyy");
            return (
                "=SUBSTITUTE(" + '"' + newDate + '"' + "," + '"' + "-" + '"' + "," + '"' + "/" + '"' + ")"
            )
        }
    }

    const imageLinkFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <a target="_blank" href={cell}>View</a>
        )
    }

    const imageLinkFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=HYPERLINK(" + '"' + cell + '",' + '"' + "View" + '"' + ")"
        )
    }




    const OpenPopup = () => {
        setHidden(false);
        if (hiddenRef.current) {
            // setPage(1);
            // setDetailData([]);
            //setSelectedRow({})
        }
    }


    let onCustomerFilter;
    let onCarrierFilter;
    const onCustomerChangeFilter = (selectedOwner, selectedCust) => {
        debugger;
        if (selectedCust >= 0) {
            setOwnerKey(selectedOwner);
            setCustomerKey(selectedCust);
            setOwnerKey(selectedOwner);
            LoadSummaryData(selectedOwner, selectedCust);
        }
        else {
            setBusinessRevRpt([]);
        }
    };

    const onCarrierChangeFilter = (val) => {
        //onCarrierFilter(val);
        console.log(val)
    };

    const tpFormatter = (cell, row, rowIndex, formatExtraData) => {
        // console.log(row.billType);
        let isTotal = false;
        if (row.billType === 'TOTAL') {
            isTotal = true
        }

        return (
            isTotal ? <span></span> : <span>{cell}</span>
        )
    }

    const tpFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        // console.log(row.billType);
        let isTotal = false;
        if (row.billType === 'TOTAL') {
            isTotal = true
        }

        return (
            isTotal ? 'TOTAL' : cell
        )
    }

    const billtypeFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        // console.log(row.billType);
        let isTotal = false;
        if (cell === 'TOTAL') {
            isTotal = true
        }

        return (
            isTotal ? <span><b>TOTAL</b></span> : <span>{cell}</span>

        )
    }

    const handleNullValues = (cell, row, rowIndex, formatExtraData) => {
        let result = cell;

        if (cell === null) {
            result = ''; // Convert null to blank
        }

        return result;
    }

    const columns = [
        {
            dataField: 'ownerName',
            text: 'Owner',
            headerStyle: { width: '150px', textAlign: 'center' },
            filter: customFilter(),
            // sort: true,
            formatter: tpFormatter,
            csvFormatter: tpFormattercsv,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'customerName',
            text: 'Customer',
            headerStyle: { width: '150px', textAlign: 'center' },
            filter: customFilter(),
            // sort: true,
            formatter: tpFormatter,
            csvFormatter: tpFormattercsv,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'region',
            text: 'Region',
            headerStyle: { width: '80px', textAlign: 'center' }
            // filter: customFilter(),
            // sort: true,
            // formatter: tpFormatter,
            // csvFormatter: tpFormatter
            // filterRenderer: (onFilter, column) =>
            //     <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'leadBusinessReviewDesc',
            text: 'Who will Lead Business Reviews?',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left',
            // formatter: tpFormatter,
            csvFormatter: handleNullValues
        },
        {
            dataField: 'frequencyDesc',
            text: 'Frequency of Business Reviews',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left',
            // formatter: tpFormatter,
            csvFormatter: handleNullValues
        },
        {
            dataField: 'lastReviewDate',
            text: 'Last Business Review Date',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left',
            formatter: invoiceDateFormatter,
            csvFormatter: invoiceDateFormattercsv

        },
        {
            dataField: 'nextReviewDate',
            text: 'Next Business Review Date',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left',
            formatter: invoiceDateFormatter,
            csvFormatter: invoiceDateFormattercsv
        },
        {
            dataField: 'customerSatisfactionRankingDesc',
            text: 'Customer Satisfaction Ranking',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left',
            // formatter: tpFormatter,
            csvFormatter: handleNullValues

        },
        {
            dataField: 'newBusinessOpportunitiesDesc',
            text: 'New Business Opportunities? Yes or No',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'left',
            // formatter: tpFormatter,
            csvFormatter: handleNullValues

        },
        {
            dataField: 'comments',
            text: 'Notes',
            headerStyle: { width: '135px', textAlign: 'center' },
            align: 'left',
            // formatter: tpFormatter,
            csvFormatter: handleNullValues
        },

    ];

    const pagingOptioins = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    }

    const observer = useRef(
        new IntersectionObserver((entries, pagingOptioins) => {
            const first = entries[0];
            if (first.isIntersecting) {
                setPage((no) => no + 1);
            }
        })
    );

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        const currentElement = lastElement;
        const currentObserver = observer.current;

        if (currentElement) {
            currentObserver.observe(currentElement);
        }

        return () => {
            if (currentElement) {
                currentObserver.unobserve(currentElement);
            }
        };
    }, [lastElement]);

    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
    }) => (
        <div className="btn-group" role="group">
            {
                options.map((option) => {
                    const isSelect = currSizePerPage === `${option.page}`;
                    return (
                        <button
                            key={option.text}
                            type="button"
                            onClick={() => onSizePerPageChange(option.page)}
                            className={`btn ${isSelect ? 'btn-secondary' : 'btn-warning'}`}
                        >
                            {option.text}
                        </button>
                    );
                })
            }
        </div>
    );

    const options = {
        sizePerPageRenderer,
        sizePerPageList: [{
            text: '50', value: 50
        }, {
            text: '100', value: 100
        },
        {
            text: '200', value: 200
        }, {
            text: 'All', value: BusinessRevRpt.length
        }]
    };

    const breadcumTitle = <div dangerouslySetInnerHTML={{ __html: 'Business Review Report' }} />;

    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />
                    <div className='pt-1 px-3 pb-3 py-3'>

                        {/* <Breadcrumbs title="Invoices Processed By Character ( Top 10 Bills By Greatest Number of Character)" /> */}
                        <Breadcrumbs title={breadcumTitle} />
                        {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}
                        <div className='sticky-top-content'>
                            <SettingsTopFilter oncustom={onCustomerChangeFilter} oncustom1={onCarrierChangeFilter} criData={criData} isDateDropdownHidden={true} />
                        </div>
                        {/* <div className='row mb-1'>
                            <div className='col-1 pe-0'>Top Bills</div>
                            <div className='col-2 topbills'>
                                <select id="topbills" onChange={onTopBillsSelect}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                </select>
                            </div>
                        </div> */}

                        <div className='d-flex'>

                            <div className="table-container">
                                <div className='grid-toggle'>
                                    <div className='main-table-text dropup'>
                                        {BusinessRevRpt.length > 0 ?
                                            <ToolkitProvider
                                                keyField="freightBillKey"
                                                data={BusinessRevRpt}
                                                columns={columns}
                                                exportCSV>
                                                {
                                                    props => (
                                                        <div>
                                                            <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: "right" }}>
                                                                <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export
                                                                </button>
                                                            </div>
                                                            <BootstrapTable
                                                                classes='table table-striped table-hover table-width'
                                                                headerClasses='table-top'
                                                                bootstrap4
                                                                pagination={paginationFactory(options)}
                                                                {...props.baseProps}
                                                                filter={filterFactory()}
                                                            />
                                                            {/* <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export</button> */}
                                                            {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export</ExportCSVButton> */}
                                                        </div>
                                                    )
                                                }
                                            </ToolkitProvider> : <>
                                                <MycustomDesignGrid column={columns} />
                                            </>}
                                    </div>
                                </div>
                            </div>
                            <SettingsRightFilterToggle onSearchClick={searchOnClick} dateDivVisible={dateDivVisible} />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}